import React, { Component } from 'react';
import { bool, func, shape, string } from 'prop-types';
import { connect } from 'react-redux';
import { getConsultById as getConsultByIdSelector } from 'Selectors/webChat/consults';
import {
  CONTEXT_MENU_CONSULT_PATIENT,
  CONTEXT_MENU_CONSULT_SUMMARY,
  CONTEXT_MENU_CONSULT_OPTIONS,
  CONTEXT_MENU_CONSULT_DETAILS,
  CONTEXT_MENU_CONSULT_FEE,
  CONTEXT_MENU_ALL_MEDIA,
  CONTEXT_MENU_TERM_OF_CONSULT,
  CONTEXT_MENU_CONSULT_HISTORY,
  CONTEXT_MENU_MC_HISTORY,
} from 'Constants/consults';
import * as Actions from 'Redux/modules/webChat/actions';

import PatientInfo from './PatientInfo/PatientInfo';
import ConsultSummary from './ConsultSummary';
import ConsultDetails from './ConsultDetails';
import ConsultMenu from './ConsultMenu/ConsultMenu';
import ConsultFee from './ConsultFee/ConsultFee';
import PaymentTerm from './PaymentTerm';
import ConsultHistory from './ConsultHistory/ConsultHistory';
import AttachmentFiles from './AttachmentFiles/AttachmentFiles';
import McHistoryContextMenu from './McHistory/McHistoryContextMenu';

class ContextMenu extends Component {
  getConsultFee = consultId => {
    const { consult } = this.props;
    if (consult.status === 2) {
      this.props.getConsultFee(consultId);
    }
    if (consult.status === 1) {
      this.props.consultFeeEstimate(consultId, 0);
    }
  };

  closeContextMenu = () => {
    this.props.closeMenu();
  };

  render() {
    const {
      doctor,
      consult,
      openPOS,
      consultFee,
      contextMenu,
      conversation,
      consultDetails,
      openMemoRandum,
      changeContextMenu,
      openFinishConsult,
      openPrescriptionModal,
      openReferralMemo,
      openMedicalCertificate,
      isMinimize,
      pendingConsultActive,
      getConsultById,
    } = this.props;

    const pendingConsult = getConsultById(pendingConsultActive);
    const reFormatConsultFee = pendingConsult ? { data: pendingConsult.consultFee } : consultFee;
    const { type } = contextMenu;
    const currentType = type[type.length - 1];
    const isLoading = consultDetails.status.loading === 0;
    switch (currentType) {
      case CONTEXT_MENU_CONSULT_PATIENT:
        return conversation || pendingConsultActive ? (
          <PatientInfo
            closeContextMenu={this.closeContextMenu}
            conversation={pendingConsult ? { latestConsult: pendingConsult } : conversation}
          />
        ) : (
          <div />
        );
      case CONTEXT_MENU_CONSULT_FEE:
        return (
          <ConsultFee
            doctor={doctor}
            consult={pendingConsult || consult}
            contextMenu={contextMenu}
            consultDetails={pendingConsult || consultDetails}
            closeContextMenu={this.closeContextMenu}
            consultId={pendingConsult?.id || conversation.latestConsult.id}
          />
        );
      case CONTEXT_MENU_CONSULT_OPTIONS:
        return (
          <ConsultMenu
            doctor={doctor}
            consult={consult || pendingConsult}
            openPOS={openPOS}
            consultFee={reFormatConsultFee}
            conversation={pendingConsult ? { latestConsult: pendingConsult } : conversation}
            openMemoRandum={openMemoRandum}
            getConsultFee={this.getConsultFee}
            changeContextMenu={changeContextMenu}
            openFinishConsult={openFinishConsult}
            closeContextMenu={this.closeContextMenu}
            openMedicalCertificate={openMedicalCertificate}
            openPrescriptionModal={openPrescriptionModal}
            openReferralMemo={openReferralMemo}
            isMinimize={isMinimize}
            pendingConsultActive={pendingConsultActive}
          />
        );
      case CONTEXT_MENU_CONSULT_SUMMARY:
        return (
          <ConsultSummary
            doctor={doctor}
            consult={consult || pendingConsult}
            contextMenu={contextMenu}
            loadingConsult={isLoading}
            changeContextMenu={changeContextMenu}
            closeContextMenu={this.closeContextMenu}
          />
        );
      case CONTEXT_MENU_CONSULT_DETAILS:
        return (
          <ConsultDetails
            consult={consult || pendingConsult}
            isFetching={isLoading}
            contextMenu={contextMenu}
            closeContextMenu={this.closeContextMenu}
          />
        );
      case CONTEXT_MENU_ALL_MEDIA:
        return (
          <AttachmentFiles
            consult={consult}
            closeContextMenu={this.closeContextMenu}
            conversationActiveId={conversation.id}
          />
        );
      case CONTEXT_MENU_TERM_OF_CONSULT:
        return <PaymentTerm contextMenu={contextMenu} closeContextMenu={this.closeContextMenu} />;
      case CONTEXT_MENU_CONSULT_HISTORY:
        return (
          <ConsultHistory
            changeContextMenu={changeContextMenu}
            closeContextMenu={this.closeContextMenu}
            conversation={conversation}
          />
        );
      // case CONTEXT_MENU_SEARCH_MESSAGE:
      //   return (
      //     <SearchMessage
      //       closeContextMenu={this.closeContextMenu}
      //       consult={consult}
      //     />
      //   );

      case CONTEXT_MENU_MC_HISTORY:
        return <McHistoryContextMenu closeContextMenu={this.closeContextMenu} />;
      default:
        return null;
    }
  }
}

ContextMenu.propTypes = {
  consult: shape({}),
  openPOS: func.isRequired,
  closeMenu: func.isRequired,
  doctor: shape({}).isRequired,
  getConsultFee: func.isRequired,
  openMemoRandum: func.isRequired,
  consultFee: shape({}).isRequired,
  contextMenu: shape({}).isRequired,
  conversation: shape({}).isRequired,
  changeContextMenu: func.isRequired,
  // getConsultDetails: func.isRequired,
  openFinishConsult: func.isRequired,
  consultDetails: shape({}).isRequired,
  openPrescriptionModal: func.isRequired,
  openReferralMemo: func.isRequired,
  openMedicalCertificate: func.isRequired,
  isMinimize: bool,
  pendingConsultActive: string.isRequired,
  getConsultById: func.isRequired,
  consultFeeEstimate: func.isRequired,
};

ContextMenu.defaultProps = {
  consult: {},
  isMinimize: false,
};

const mapStateToProps = (state, props) => ({
  consultFee: state.webChat.consultFee,
  consultDetails: state.webChat.consults,
  doctor: state.webChat.doctor.data,
  pendingConsultActive: state.webChat.consults.pendingConsultActive,
  getConsultById: id => getConsultByIdSelector(state, id),
  consult: getConsultByIdSelector(state, props.contextMenu.data.consultId),
});

const mapDispatchToProps = {
  getConsultFee: Actions.consultFeeRetrieve,
  consultFeeEstimate: Actions.consultFeeEstimate,
  // getConsultDetails: Actions.consultDetails,
};

export default connect(mapStateToProps, mapDispatchToProps)(ContextMenu);
